var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-row",
        { class: `mt-${_vm.marginTop}` },
        [
          _c("b-col", {
            staticClass: "d-none d-sm-block",
            attrs: { cols: "2", sm: "4" },
          }),
          _c(
            "b-col",
            {
              staticClass: "float-right my-1",
              attrs: { "align-self": "end", cols: "6", sm: "4" },
            },
            [
              !_vm.viewMode
                ? _c(
                    "b-button",
                    {
                      staticClass: "btnActionFamily",
                      attrs: { type: "button", variant: "outline-secondary" },
                      on: { click: _vm.handleCancel },
                    },
                    [_vm._v(_vm._s(_vm.$t("lang.buttons.cancel")))]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "b-col",
            {
              staticClass: "float-right my-1",
              attrs: { "align-self": "end", cols: "6", sm: "4" },
            },
            [
              _c(
                "b-button",
                {
                  staticClass: "btnActionFamily",
                  class: {
                    "btn-outline-dark": !_vm.enabled,
                    "not-allowed": !_vm.enabled,
                    "btn-secondary": _vm.enabled,
                  },
                  attrs: { type: "button" },
                  on: { click: _vm.confirmButtonClick },
                },
                [
                  _vm._v(
                    _vm._s(
                      `${
                        _vm.viewMode
                          ? _vm.$t("lang.buttons.back")
                          : _vm.$t("lang.buttons.confirm")
                      }`
                    )
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }